export default "__VITE_ASSET__BxM7Lwq___"